/**
 * Section access model — every report section is one of:
 *   'hidden' → not rendered at all, no nav entry.
 *   'public' → visible to anyone with the report URL.
 *   'authed' → visible only after PIN sign-in (ReportAuthContext).
 *
 * Resolution order:
 *   1. settings.reportSectionAccess[id]  (new tri-state field)
 *   2. settings.reportSections[id]       (legacy boolean; true→public, false→hidden)
 *   3. caller's defaultVisible           (true→public, false→hidden)
 *
 * This keeps every existing instance working: as long as nobody touches
 * the new field, the legacy boolean keeps driving visibility. The first
 * "Authed" toggle in the admin UI writes to the new field.
 */
export const ACCESS_HIDDEN = 'hidden';
export const ACCESS_PUBLIC = 'public';
export const ACCESS_AUTHED = 'authed';

const ALL = new Set([ACCESS_HIDDEN, ACCESS_PUBLIC, ACCESS_AUTHED]);

export function resolveSectionAccess(settings, id, defaultVisible = true) {
  const next = settings?.reportSectionAccess?.[id];
  if (next && ALL.has(next)) return next;
  const legacy = settings?.reportSections?.[id];
  if (legacy === true) return ACCESS_PUBLIC;
  if (legacy === false) return ACCESS_HIDDEN;
  return defaultVisible ? ACCESS_PUBLIC : ACCESS_HIDDEN;
}
